import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader, TableComponent} from '../../../shared/table/TableComponent';
import {FormBuilder, FormControl, UntypedFormGroup} from '@angular/forms';
import {PagedListOfApplicationCounty} from '../../../../services/api.client';
import {Disposable} from '../../../../utilities/Disposable';
import {takeUntil} from 'rxjs/operators';
import {ApplicationCountyService} from '../../../../services/applicationCounty.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-application-county-list',
    templateUrl: './application-county-list.component.html',
    styleUrls: ['./application-county-list.component.scss'],
    standalone: false
})
export class ApplicationCountyListComponent extends Disposable implements OnInit, AfterViewInit {

  @ViewChild(TableComponent) table: TableComponent;

  get nameControl(): FormControl {
    return this.form.get('name') as FormControl;
  }

  constructor(
      private _formBuilder: FormBuilder,
      private _applicationCountyService: ApplicationCountyService,
      private _router: Router
  ) {
    super();
  }

  form: UntypedFormGroup;

  tableHeaders: ITableHeader[] = [
    {text: 'County', sortKey: 'Name'},
    {text: 'STL Water Internal', sortKey: 'IsStlWaterActiveInternal'},
    {text: 'STL Water Public Application', sortKey: 'IsStlWaterActiveExternal'},
    //{text: 'STL Water Managing Fund/Organization', sortKey: 'StlWaterFundAdministrativePledgeTypeId'},
    {text: 'UHONS Internal', sortKey: 'IsUhonsActiveInternal'},
    {text: 'UHONS Public Application', sortKey: 'IsUhonsActiveExternal'},
    //{text: 'UHONS Managing Fund/Organization', sortKey: 'UhonsFundAdministrativePledgeTypeId'},
  ];

  // sorting
  currentSortName = 'Name';
  currentSorting = false;

  // pagination
  limit = 10;
  currentPage = 1;
  maxSize = 1;
  totalCount: number;

  // 003-retire-ngrx (US2): page state is component-local now — the list is a
  // same-page fetch->render round-trip.
  pagedListOfApplicationCounties: PagedListOfApplicationCounty;

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.filterCounties();
  }

  initForm(): void {
    this.form = this._formBuilder.group({
      name: new FormControl<string>('')
    });
  }

  sortCounties(options: ITableHeader): void {
    this.currentSortName = options.sortKey;
    this.currentSorting = !options.ascending;
    this.filterCounties();
  }

  setLimit(limit: number): void {// # of rows per page
    this.limit = limit;
    this.filterCounties();
  }

  setPage(page: number): void {
    setTimeout(() => {
      this.currentPage = page; // set current page
      this.filterCounties();
    });
  }

  filterCounties(): void {
    const request = this._applicationCountyService.searchCounties(
        this.nameControl.value,
        this.currentSortName,
        this.currentSorting,
        this.limit,
        (this.currentPage - 1) * this.limit
    );
    this.table.request = request;
    request
        .pipe(takeUntil(this.$destroyed))
        .subscribe(pagedListOfApplicationCounties => {
          this.pagedListOfApplicationCounties = pagedListOfApplicationCounties;
          this.totalCount = pagedListOfApplicationCounties?.totalCount;
        });
  }

  showActiveText(isActive: boolean): string {
    return isActive ? 'Enabled' : 'Disabled';
  }
}
